<template>
  <div>
    <navbar></navbar>
    <div class="d-flex justify-content-center mt-4">
      <amplify-sign-out v-bind:signOutConfig="signOutConfig"></amplify-sign-out>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
export default {
  components: { Navbar },
  data() {
    return {
      signOutConfig: {
        signOutButton: "サインアウト"
      }
    };
  }
};
</script>
